import React, { FC, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IMediaItem from '../../interfaces/umbracoNodes/mediaItem';
import IPageViewModel from '../../interfaces/umbracoNodes/pageViewModel';
import { Column, Columns } from '../base/grid';
import { H2 } from '../base/typography';
import * as StyledDynamicForm from './dynamicForm.styles';

interface Props {
	form: IPageViewModel;
	formImage: IMediaItem;
	formHeadline: string;
}

const DynamicForm: FC<Props> = ({ form, formImage, formHeadline }) => {
	const { t } = useTranslation('generalForm');
	const [iframeHasLoaded, setIframeHasLoaded] = useState(false);

	const iframeRef = useRef(null);
	const formColumnSize = formImage ? 1 / 2 : 1;

	const formColumnSizeLarge = formImage ? formColumnSize : 5 / 6;

	const onIframeLoad = () => {
		const iframe = iframeRef.current;
		iframe.height = '';
		iframe.height = iframe.contentWindow.document.body.scrollHeight + 'px';
		setIframeHasLoaded(true);
	};

	return (
		<StyledDynamicForm.Wrapper>
			<Columns>
				{form && (
					<Column tablet={1} desktopSmall={1} desktopLarge={formColumnSizeLarge}>
						<StyledDynamicForm.FormWrapper>
							{formHeadline && <H2 marginBottom="3rem">{formHeadline}</H2>}
							{!iframeHasLoaded && <p>{t('onLoad')}</p>}
							<iframe src={form.Url} title={form.Name} ref={iframeRef} onLoad={onIframeLoad} />
						</StyledDynamicForm.FormWrapper>
					</Column>
				)}
				{formImage && (
					<StyledDynamicForm.ImageColumn desktopLarge={formColumnSize}>
						<StyledDynamicForm.FormImage image={formImage.Src} />
					</StyledDynamicForm.ImageColumn>
				)}
			</Columns>
		</StyledDynamicForm.Wrapper>
	);
};

export default DynamicForm;
